<template>
    <div class="menu-items flex justify-between">
        <a href="#" 
            class="text-lg text-white uppercase font-zen-dots font-normal leading-5 no-underline antialiased" 
            :title="$root.app.name">
            <AppLogo />
        </a>
        <a data-testid="support-email" :href="$root.app.mailtoSupport" class="text-lg text-white no-underline">Contact Us</a>
    </div>
</template>

<script>
import AppLogo from "./../../components/AppLogo";

export default {
    components: {
        AppLogo
    },
};
</script>